// Mount the AI Token module: hand `createTokenModule` a lazy host (`./token-host`, which holds the
// heavy app imports) instead of a built one, as `register-hosting.tsx` does. `service-modules.ts` and
// `service-scopes.ts` take the routes and the catalog scopes from HERE. This file must stay light: it
// is in the entry chunk.
import { createTokenModule } from '@vnetwork/margarita-token';

export const token = createTokenModule(() => import('./token-host').then((m) => m.tokenHost));
